import { Button, Grid, InputLabel, Typography, useMediaQuery, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { LoginAddressStyles as classes } from './LoginAddressStyles';
import LoginAddressImage from '../../images/LoginAddressImage.svg';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { MobileInput } from '../LeadGeneration/MobileInput/MobileInput';
import {
  ACC_ADDRESS,
  ACC_COUNTRY,
  ACC_INFO_CITY,
  ACC_INFO_STATE,
  ACC_INFO_ZIPCODE,
  LIBRE_AHORRA_BUNDLE,
  EMAIL,
  INVALID_FORMAT_ERR,
  MANDATORY_FIELD_ERR,
  MOBILE,
  REQUIRED,
  VALIDATION_BACKSPACE,
} from '../../constants';
import { CustomInput } from '../LeadGeneration/CustomInput/CustomInput';
import AddressCard from './AddressCard';
import CustomSwitch from '../LeadGeneration/Switch/CustomSwitch';
import './LoginAddressStyles.css';
import {
  loginAddress2Change,
  loginCountryChange,
  loginStateChange,
  loginCityChange,
  loginZipcodeChange,
} from './LoginAddressUtils';
import {
  formatPhoneNumber,
  formatPhoneNumberForVI,
  getEmailErrorType,
} from '../LeadGeneration/StepOne/ContactUtils';
import LoginHomeAddress from './LoginHomeAddress';
import { checkInvalidMobileNumber, commonTernary, isBundle } from '../commonCode';
import {
  getEmailVerificationDataExpress,
  mobileValidationExpress,
} from '../../services/validationService';
import { saveOtpAddressScreen } from '../../services/expressFlowService';
import { productNameURLMapping } from '../../services/productNameURLMapping';
import Loader from '../Loader/Loader';
import { LayoutStyles as LayoutClasses } from '../Bundle/LayoutStyles';
import Footer from '../Footer/Footer';

const LoginAddress = ({ history }) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const themes = useTheme();
  const isMobile = useMediaQuery(themes?.breakpoints?.down('sm'), {
    defaultMatches: true,
  });

  const {
    setCurrentPage,
    location,
    setLoginHomeAddress,
    loginHomeAddress,
    loginHomeAddressErrors,
    setLoginHomeAddressErrors,
    loginDetails,
    setLoginDetails,
    selectedAddress,
    setSelectedAddress,
    loginDetailsErrors,
    setLoginDetailsErrors,
    isNewAddress,
    setIsNewAddress,
    productName,
    productType,
    language,
    customerAppId,
    isEtbAddressDirty,
    setIsEtbAddressDirty,
    setIsScreenFiveDirty,
    theme,
  } = leadGenerationContext;
  const [isValidating, setIsValidating] = useState(false);
  useEffect(() => {
    setCurrentPage('login-address');

    if (loginDetails?.address?.LineOne && isBundle(productName)) {
      const selectedAddr = loginDetails?.address;
      const address = {
        LineOne: commonTernary(selectedAddr?.LineOne, selectedAddr?.LineOne, null),
        LineTwo: commonTernary(selectedAddr?.LineTwo, selectedAddr?.LineTwo, null),
        AddrState: commonTernary(selectedAddr?.AddrState, selectedAddr?.AddrState, null),
        AddrCountry: commonTernary(selectedAddr?.AddrCountry, selectedAddr?.AddrCountry, null),
        AddrCity: commonTernary(selectedAddr?.AddrCity, selectedAddr?.AddrCity, null),
        ZipCode: commonTernary(selectedAddr?.ZipCode, selectedAddr?.ZipCode, null),
      };
      setSelectedAddress(address);
    }
  }, []);

  useEffect(() => {
    if (loginDetails.phone && loginDetails.flag) {
      const areaCode1 = loginDetails.phone.substring(0, 3);
      const phone1 = loginDetails.phone.substring(3);
      const formattedPhoneNumber = `${phone1.slice(0, 3)}-${phone1.slice(3)}`;
      setLoginDetails((prevState) => ({
        ...prevState,
        phone: formattedPhoneNumber,
        areaCode: areaCode1,
        flag: false,
      }));
    }
    if (!loginDetails.phone) {
      setLoginDetails((prevState) => ({
        ...prevState,
        flag: false,
      }));
    }
  }, []);
  const handleToggleSwitchAddress = (e) => {
    if (isBundle(productName)) {
      setIsNewAddress(!isNewAddress);
    } else {
      setIsNewAddress(e.target.checked);
    }
    setIsEtbAddressDirty(true);
    setIsScreenFiveDirty(true);
    setSelectedAddress({});
    if (!e.target.checked) {
      setLoginHomeAddress((prevState) => ({
        ...prevState,
        country: '',
        state: '',
        permanentCountry: '',
        permanentState: '',
        defaultCountryBasedOnLocation: '',
        address1: '',
        address2: '',
        city: '',
        zipCode: '',
      }));
      setLoginHomeAddressErrors({});
    }
  };

  const handleChange = (e) => {
    setIsEtbAddressDirty(true);
    setIsScreenFiveDirty(true);
    if (e.target.name === ACC_ADDRESS) {
      loginAddress2Change(e, leadGenerationContext);
    } else if (e.target.name === ACC_COUNTRY) {
      loginCountryChange(e, leadGenerationContext);
    } else if (e.target.name === ACC_INFO_STATE) {
      loginStateChange(e, leadGenerationContext);
    } else if (e.target.name === ACC_INFO_CITY) {
      loginCityChange(e, leadGenerationContext);
    } else if (e.target.name === ACC_INFO_ZIPCODE) {
      loginZipcodeChange(e, leadGenerationContext);
    }
  };
  const areaCodeChange = (e) => {
    if (e.target.value.match(/^\d+$/) || e.key === VALIDATION_BACKSPACE) {
      setLoginDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setLoginDetailsErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.value.length < 3) {
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Area Code should have 3 digits',
        }));
      }
      if (e.target.value.length === 3 && loginDetails?.phone?.length === 8) {
        setLoginDetailsErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
        setLoginDetailsErrors((prevState) => ({ ...prevState, phone: '' }));
      }
    } else if (e.target.value === '') {
      setLoginDetails((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setLoginDetailsErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Area Code is Mandatory',
      }));
    } else {
      setLoginDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setLoginDetailsErrors((prevState) => ({
        ...prevState,
        [e.target.name]: INVALID_FORMAT_ERR,
      }));
    }
  };
  const phoneLengthCheck = (e) => {
    if (e.target.value.length < 8) {
      const formattedPhoneNumber = formatPhoneNumber(e.target.value);
      setLoginDetails((prevState) => ({
        ...prevState,
        [e.target.name]: formattedPhoneNumber,
      }));
      if (e.target.value.length < 7 || formattedPhoneNumber.length < 7) {
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Mobile number should have 7 digits',
        }));
      } else {
        setLoginDetailsErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      }
    }
  };
  const phoneNumberLength = (e) => {
    if (e.target.value.length < 15) {
      const formattedPhoneNumber = formatPhoneNumberForVI(e.target.value);
      setLoginDetails((prevState) => ({
        ...prevState,
        [e.target.name]: formattedPhoneNumber,
      }));
      setLoginDetailsErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.value.length < 10 || formattedPhoneNumber.length < 10) {
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Mobile number should have 10 digits',
        }));
      }
    }
  };

  const phoneChange = (e) => {
    if (location !== 'VI') {
      if (e.target.value.match(/^\d/) || e.key === VALIDATION_BACKSPACE) {
        phoneLengthCheck(e);
      } else if (e.target.value === '') {
        setLoginDetails((prevState) => ({ ...prevState, [e.target.name]: '' }));
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: MANDATORY_FIELD_ERR,
        }));
      } else {
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: INVALID_FORMAT_ERR,
        }));
      }
    } else {
      if (e.target.value && e.target.value.length === 13) {
        e.target.value = formatPhoneNumberForVI(e.target.value);
      }
      if (e.target.value?.match(/^\d/) || e.key === VALIDATION_BACKSPACE) {
        phoneNumberLength(e);
      } else if (e.target.value === '') {
        setLoginDetails((prevState) => ({ ...prevState, [e.target.name]: '' }));
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: MANDATORY_FIELD_ERR,
        }));
      } else {
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [e.target.name]: INVALID_FORMAT_ERR,
        }));
      }
    }
  };
  const mobileEmailChange = (e) => {
    setIsEtbAddressDirty(true);
    setIsScreenFiveDirty(true);
    switch (e.target.name) {
      case 'areaCode':
        areaCodeChange(e);
        break;

      case 'phone':
        phoneChange(e);
        break;
      case 'email':
        if (
          e.target.value.match(
            /^([a-zA-Z0-9_.-]+)@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/
          )
        ) {
          const emailFirstPart = e.target.value.split('@');
          if (
            emailFirstPart[0].charAt(0) !== '.' &&
            emailFirstPart[0].charAt(0) !== '-' &&
            emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '-' &&
            emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '.' &&
            !e.target.value.match(/[.\-_]{2,}/)
          ) {
            setLoginDetails((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }));
            setLoginDetailsErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
          } else {
            setLoginDetails((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }));
            setLoginDetailsErrors((prevState) => ({
              ...prevState,
              [e.target.name]: INVALID_FORMAT_ERR,
            }));
          }
        } else if (e.target.value === '') {
          setLoginDetails((prevState) => ({ ...prevState, [e.target.name]: '' }));
          setLoginDetailsErrors((prevState) => ({
            ...prevState,
            [e.target.name]: MANDATORY_FIELD_ERR,
          }));
        } else {
          setLoginDetails((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
          setLoginDetailsErrors((prevState) => ({
            ...prevState,
            [e.target.name]: INVALID_FORMAT_ERR,
          }));
        }
        break;
      default:
        break;
    }
  };
  const isAddressFieldValid = () => {
    let isAddValid = true;
    if (!loginHomeAddress?.address1) {
      isAddValid = false;
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        address1: MANDATORY_FIELD_ERR,
      }));
    }
    if (!loginHomeAddress?.country) {
      isAddValid = false;
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        country: MANDATORY_FIELD_ERR,
      }));
    }
    if (!loginHomeAddress?.state) {
      isAddValid = false;
      setLoginHomeAddressErrors((prevState) => ({ ...prevState, state: MANDATORY_FIELD_ERR }));
    }
    if (!loginHomeAddress?.city) {
      isAddValid = false;
      setLoginHomeAddressErrors((prevState) => ({ ...prevState, city: MANDATORY_FIELD_ERR }));
    }
    if (!loginHomeAddress?.zipCode) {
      isAddValid = false;
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        zipCode: MANDATORY_FIELD_ERR,
      }));
    }
    for (const key in loginHomeAddressErrors) {
      if (loginHomeAddressErrors[key]) {
        isAddValid = false;
        break;
      }
    }
    return isAddValid;
  };
  const isFormValid = () => {
    let isValid = true;
    if (!loginDetails.phone) {
      setLoginDetailsErrors((prevState) => ({ ...prevState, phone: MANDATORY_FIELD_ERR }));
    }
    if (!loginDetails.email) {
      setLoginDetailsErrors((prevState) => ({ ...prevState, email: MANDATORY_FIELD_ERR }));
    }
    if (isNewAddress) {
      isValid = isAddressFieldValid();
    }
    for (const key in loginDetailsErrors) {
      if (loginDetailsErrors[key]) {
        isValid = false;
        break;
      }
    }
    return isValid;
  };
  const mobileValidCheck = (response, errorToShowElement) => {
    let isValidCheck = false;
    if (response && response.status === 200) {
      if (response.data[0] && response.data[0]?.status === 'Invalid') {
        setLoginDetailsErrors((prevState) => ({
          ...prevState,
          [errorToShowElement]: `* ${response.data[0].message}`,
        }));
        const element = document.getElementById(errorToShowElement);
        if (element) {
          element.focus();
        }
      }
      if (response.data[0] && response.data[0]?.status === 'Valid') {
        isValidCheck = true;
        setLoginDetailsErrors((prevState) => ({ ...prevState, [errorToShowElement]: '' }));
      }
    }
    return isValidCheck;
  };
  const validateMobile = async (areaCode, errorToShowElement, phone) => {
    let valid = false;
    let phoneNumber1 = null;
    let response1 = null;
    if (location === 'VI') {
      phoneNumber1 = phone?.replace(/\D+/g, '');
      if (phoneNumber1 && phoneNumber1?.length === 10) {
        response1 = await mobileValidationExpress(
          phoneNumber1,
          leadGenerationContext.accessToken,
          customerAppId
        );
      }
    } else {
      phoneNumber1 = `${areaCode}${phone}`;
      if (phoneNumber1 && phoneNumber1?.length === 11) {
        response1 = await mobileValidationExpress(
          phoneNumber1,
          leadGenerationContext.accessToken,
          customerAppId
        );
      }
    }
    valid = mobileValidCheck(response1, errorToShowElement);
    return { isPhoneValid: valid, validationResponse: response1 ? response1?.data[0] : null };
  };
  let emailValid = false;
  let emailErrorType = null;
  let emailValidationData = null;
  const emailVaildCheck = (data) => {
    if (data.status === 'Valid') {
      emailValid = true;
      setLoginDetailsErrors((prevState) => ({ ...prevState, email: '' }));
    } else {
      setLoginDetailsErrors((prevState) => ({
        ...prevState,
        email: `* ${data.message}`,
      }));
      emailErrorType = getEmailErrorType(data.message);
    }
  };
  const emailValidation = async () => {
    if (loginDetailsErrors?.email === INVALID_FORMAT_ERR) {
      const emailElement = document.getElementById('email');
      emailElement.setSelectionRange(0, loginDetails?.email?.length);
      emailElement.focus();
    } else if (loginDetails?.email) {
      const response = await getEmailVerificationDataExpress(
        loginDetails?.email,
        leadGenerationContext.accessToken,
        customerAppId
      );
      if (response && response.status === 200 && response.data[0]) {
        const data = response.data[0];
        emailVaildCheck(data);
        emailValidationData = data;
      }
      if (emailErrorType) {
        let emailhighlightStartIndex = 0;
        let emailhighlightEndIndex = 0;
        const emailElement = document.getElementById('email');
        if (emailErrorType === 'Mailbox_Error') {
          emailhighlightEndIndex = loginDetails?.email.indexOf('@');
          emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
          emailElement.focus();
        }
        if (emailErrorType === 'Domain_Error') {
          emailhighlightStartIndex = loginDetails.email.indexOf('@') + 1;
          emailhighlightEndIndex = loginDetails?.email.length;
          emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
          emailElement.focus();
        }
      }
    }
    return { valid: emailValid, validationData: emailValidationData };
  };
  const getAddressObj = () => {
    let obj = null;
    if (isNewAddress) {
      obj = {
        line1: commonTernary(loginHomeAddress?.address1, loginHomeAddress?.address1, null),
        line2: commonTernary(loginHomeAddress?.address2, loginHomeAddress?.address2, null),
        state: commonTernary(loginHomeAddress?.state, loginHomeAddress?.state, null),
        country: commonTernary(loginHomeAddress?.country, loginHomeAddress?.country, null),
        city: commonTernary(loginHomeAddress?.city, loginHomeAddress?.city, null),
        zipcode: commonTernary(loginHomeAddress?.zipCode, loginHomeAddress?.zipCode, null),
      };
    } else {
      obj = {
        line1: commonTernary(selectedAddress?.LineOne, selectedAddress?.LineOne, null),
        line2: commonTernary(selectedAddress?.LineTwo, selectedAddress?.LineTwo, null),
        state: commonTernary(selectedAddress?.AddrState, selectedAddress?.AddrState, null),
        country: commonTernary(selectedAddress?.AddrCountry, selectedAddress?.AddrCountry, null),
        city: commonTernary(selectedAddress?.AddrCity, selectedAddress?.AddrCity, null),
        zipcode: commonTernary(selectedAddress?.ZipCode, selectedAddress?.ZipCode, null),
      };
    }
    return obj;
  };
  let isElementFound = false;
  const focusErrorCheck = (fields, state) => {
    for (const field of fields) {
      if (!state[field]) {
        const element = document.getElementById(field);
        if (element) {
          element.focus();
          break;
        }
      }
    }
  };
  const checkEmailPhoneErrors = () => {
    const fields = ['email', 'phone', 'areaCode'];
    for (const field of fields) {
      if (loginDetailsErrors[field]) {
        const element = document.getElementById(field);
        if (element) {
          isElementFound = true;
          element.focus();
          break;
        }
      }
    }
    if (!isElementFound) {
      focusErrorCheck(fields, loginDetails);
    }
  };
  const setErrorFieldsFocus = () => {
    checkEmailPhoneErrors();
    const addressFields = ['address1', 'country', 'state', 'city', 'zipCode', 'address2'];
    for (const field of addressFields) {
      if (loginHomeAddressErrors[field]) {
        const element = document.getElementById(field);
        if (element) {
          isElementFound = true;
          element.focus();
          break;
        }
      }
    }
    if (!isElementFound) {
      focusErrorCheck(addressFields, loginHomeAddress);
    }
  };
  const handleContinue = async () => {
    let valid = true;
    let phoneValidation = false;
    setIsValidating(true);
    if (isEtbAddressDirty) {
      valid = isFormValid();
      if (valid) {
        if (
          loginDetails?.phone &&
          checkInvalidMobileNumber(loginDetails.phone, leadGenerationContext)
        ) {
          setLoginDetailsErrors((prevState) => ({
            ...prevState,
            phone: '* Invalid Phone',
          }));
        } else {
          phoneValidation = await validateMobile(
            loginDetails?.areaCode,
            'phone',
            loginDetails?.phone
          );
        }
        const validation = await emailValidation();
        if (
          phoneValidation &&
          phoneValidation?.isPhoneValid &&
          validation &&
          validation?.valid === true
        ) {
          const data = {
            productName,
            productType,
            language,
            location,
            customerAppId,
            phone: loginDetails.phone,
            areaCode: loginDetails.areaCode,
            email: loginDetails.email,
            emailVerificationResponse: validation?.validationData,
            phoneValidationResponse: phoneValidation?.validationResponse,
          };
          const resp = await saveOtpAddressScreen(
            leadGenerationContext.accessToken,
            getAddressObj(),
            data
          );
          if (resp.status === 200 || resp.status === 201) {
            setIsEtbAddressDirty(false);
            setIsValidating(false);
            history.push({
              pathname: `/${location?.toLowerCase()}/${language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
                productName
              )}/product-info`,
            });
          }
        } else {
          if (loginDetailsErrors?.email === INVALID_FORMAT_ERR) {
            const emailElement = document.getElementById('email');
            emailElement.setSelectionRange(0, loginDetails?.email?.length);
            emailElement.focus();
          } else {
            setErrorFieldsFocus();
          }
          setIsValidating(false);
        }
      } else {
        setErrorFieldsFocus();
        setIsValidating(false);
      }
    } else {
      setIsValidating(false);
      history.push({
        pathname: `/${location?.toLowerCase()}/${language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
          productName
        )}/product-info`,
      });
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const LoginAddressFields = () => (
    <>
      {language === 'EN' ? (
        <Box sx={isBundle(productName) ? classes.welcomeMessageBundle : classes.welcomeMessage}>
          {isBundle(productName) ? (
            t(LIBRE_AHORRA_BUNDLE, { defaultValue: LIBRE_AHORRA_BUNDLE })
          ) : (
            <>
              {t('Welcome to ', {
                defaultValue: `Welcome to `,
              })}

              <span style={{ color: '#f5821f' }}>
                {t('O', {
                  defaultValue: `O`,
                })}
              </span>
              {t('riental', {
                defaultValue: `riental`,
              })}
            </>
          )}
        </Box>
      ) : (
        <Box sx={isBundle(productName) ? classes.welcomeMessageBundle : classes.welcomeMessage}>
          {isBundle(productName) ? (
            t(LIBRE_AHORRA_BUNDLE, { defaultValue: LIBRE_AHORRA_BUNDLE })
          ) : (
            <>
              {t('Bienvenido a ', {
                defaultValue: `Bienvenido a `,
              })}{' '}
              <span style={{ color: '#f5821f' }}>
                {t('O', {
                  defaultValue: `O`,
                })}
              </span>
              {t('riental', {
                defaultValue: `riental`,
              })}
            </>
          )}
        </Box>
      )}
      <Box
        sx={
          isBundle(productName)
            ? classes.secondaryBundleDetailsContainer
            : classes.secondaryDetailsContainer
        }
      >
        <Grid>
          <MobileInput
            id="phone"
            dataTestId="phone_id"
            required={!isBundle(productName)}
            isBundle={isBundle(productName)}
            disabled={loginDetails.fetchedField === 'phone'}
            inputClassName={
              loginDetails.fetchedField === 'phone' ? classes.mobileInputDisabled : ''
            }
            ariaLabelForInputLabel={`${t(MOBILE, {
              defaultValue: MOBILE,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t(MOBILE, { defaultValue: MOBILE })}
            location={location || 'PR'}
            handleChange={mobileEmailChange}
            placeholder={t('Enter Mobile Number', {
              defaultValue: 'Enter Mobile Number',
            })}
            fullWidth
            phoneValue={loginDetails?.phone ? loginDetails.phone : ''}
            maxLength={location && location === 'VI' ? 10 : 7}
            inputMode="numeric"
            phoneError={loginDetailsErrors?.phone}
            maxLengthOfAreaCode={3}
            areaCodeInputMode="numeric"
            areaCodeAriaLabel={`${t('Area Code', {
              defaultValue: 'Area Code',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            areaCodeId="areaCode"
            areaCode={loginDetails?.areaCode ? loginDetails.areaCode : ''}
          />
          {loginDetailsErrors?.areaCode ? (
            <Box
              component="span"
              role="alert"
              sx={classes.error_message}
              data-testid="areacode-error"
            >
              {t(loginDetailsErrors?.areaCode, {
                defaultValue: loginDetailsErrors?.areaCode,
              })}
            </Box>
          ) : (
            <Box component="span" role="alert" sx={classes.error_message} data-testid="phone-error">
              {t(loginDetailsErrors?.phone, {
                defaultValue: loginDetailsErrors?.phone,
              })}
            </Box>
          )}
        </Grid>
        <Grid style={{ margin: '20px 0px' }}>
          <CustomInput
            id="email"
            dataTestId="email_id"
            isBundle={isBundle(productName)}
            required={!isBundle(productName)}
            disabled={loginDetails.fetchedField === 'email'}
            inputLabelAriaLabel={`${t(EMAIL, {
              defaultValue: EMAIL,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t(EMAIL, {
              defaultValue: EMAIL,
            })}
            handleChange={mobileEmailChange}
            placeholder={t('Enter Email Address', {
              defaultValue: 'Enter Email Address',
            })}
            fullWidth
            inputProps={{ 'data-testid': 'email', maxLength: 40 }}
            value={loginDetails?.email ? loginDetails.email : ''}
            error={loginDetailsErrors?.email ? loginDetailsErrors.email : ''}
          />
          <Box component="span" role="alert" sx={classes.error_message} data-testid="email-error">
            {t(loginDetailsErrors?.email, {
              defaultValue: loginDetailsErrors?.email,
            })}
          </Box>
        </Grid>
        <Grid
          className={
            isBundle(productName) ? '' : !isNewAddress ? 'addressContainerF' : 'addressContainer'
          }
          style={{ height: isNewAddress && !isBundle(productName) ? '250px' : 'inherit' }}
        >
          <InputLabel
            required={!isBundle(productName)}
            sx={{
              ...(isNewAddress ? classes.mailinAddressLabelTrue : classes.mailinAddressLabel),
              ...(isBundle && { color: theme?.palette?.mailingAddresstext?.main }),
            }}
          >
            {t('Select your Mailing Address', {
              defaultValue: 'Select your Mailing Address',
            })}
          </InputLabel>
          {!isNewAddress && (
            <AddressCard
              handleToggleSwitchAddress={handleToggleSwitchAddress}
              id={loginDetails?.address?.AddressId}
              address={loginDetails?.address}
              getValue={(val) => setSelectedAddress(val)}
              selected={selectedAddress?.AddressId}
              customerName={loginDetails?.name}
              isBundle={isBundle(productName)}
            />
          )}

          {!isBundle(productName) && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: !isNewAddress && '20px',
              }}
            >
              <Typography sx={classes.switch_heading}>
                {t('I wish to add a new mailing address', {
                  defaultValue: 'I wish to add a new mailing address',
                })}
              </Typography>
              <CustomSwitch
                id="isNewAddress"
                defaultData={isNewAddress}
                ariaLabelledby="isNewAddress"
                handleClickCheckbox={handleToggleSwitchAddress}
                dataTestId="isNewAddress_id"
              />
            </div>
          )}

          {isNewAddress && (
            <div style={{ marginTop: '20px' }}>
              <LoginHomeAddress handleChange={handleChange} />
            </div>
          )}
        </Grid>
        <Button
          disableFocusRipple
          disabled={
            (!isBundle(productName) &&
              !isNewAddress &&
              Object.keys(selectedAddress || {}).length === 0) ||
            isValidating ||
            loginHomeAddress?.country === 'VI'
          }
          onClick={handleContinue}
          sx={{
            ...classes.next_btn,
            '&.Mui-disabled': classes.next_btn_disabled,
            ...(isBundle && {
              background: theme?.palette?.orientalPrimary?.main,
              color: theme?.palette?.secondary?.main,
              '&:hover': {
                backgroundColor: theme?.palette?.orientalPrimary?.main,
              },
              '&.Mui-disabled': {
                background: theme?.palette?.disabledButtonBackground?.main,
                borderRadius: '56px',
                color: theme?.palette?.disabledButton?.main,
                border: 'none',
                width: '100% !important',
                height: '48px !important',
                font: 'normal normal 700 16px/20px Arial',
                letterSpacing: '0px',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: theme?.palette?.disabledButtonBackground?.main,
                },
                '@media (max-width: 600px)': {
                  width: '100%',
                },
              },
            }),
          }}
          data-testid="next_id"
        >
          {isBundle(productName)
            ? t('Continue', {
                defaultValue: 'Continue',
                nsSeparator: '|',
              })
            : t('Next', {
                defaultValue: 'Next',
                nsSeparator: '|',
              })}
        </Button>
      </Box>
    </>
  );

  const oldLayout = () => (
    <Box sx={classes.mainContainer}>
      <Box sx={classes.secondaryContainer}>
        <Grid container style={{ marginBottom: '20px' }}>
          {!isMobile && (
            <Grid size={{ xs: 12, sm: 4, md: 6 }} style={{ paddingTop: '30px' }}>
              <Box
                component="img"
                src={LoginAddressImage}
                alt="login address placeholder"
                sx={classes.imgStyles}
              />
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 8, md: 6 }} sx={classes.detailsContainerGrid}>
            <Box sx={classes.detailsContainer}>{LoginAddressFields()}</Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );

  // eslint-disable-next-line react/no-unstable-nested-components
  const BundleLayout = () => (
    <Grid
      container
      sx={{
        width: '100%',
        minHeight: isBundle(productName) ? '100vh' : '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isBundle(productName) ? 'space-between' : 'center',
        alignItems: 'center',
        '@media (max-width:600px)': {
          padding: '20px',
        },
      }}
    >
      <Grid size={{ lg: 5, md: 5, sm: 8, xs: 12 }}>{LoginAddressFields()}</Grid>
      <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }} sx={{ marginBottom: '13px' }}>
        <Footer />
      </Grid>
    </Grid>
  );
  return (
    <>
      {isValidating && (
        <div className="loader-style">
          <Loader />
        </div>
      )}

      {isBundle(productName) ? BundleLayout() : oldLayout()}
    </>
  );
};

export default withRouter(LoginAddress);
